import React, { useState, useEffect } from 'react';
import './NavbarDesktop.scss';

import logo from '../../assets/img/Logo.jpg';

function NavbarDesktop() {
    const [isScrolled, setIsScrolled] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            // Mettez à jour l'état en fonction de la position de défilement
            const isScrolled = window.scrollY > 50;
            setIsScrolled(isScrolled);
        };

        // Attachez le gestionnaire d'événements au scroll
        window.addEventListener('scroll', handleScroll);

        // Nettoyage de l'écouteur d'événements lors du démontage du composant
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    return (
        <nav className={`navbarDesktop ${isScrolled ? 'scrolled' : ''}`}>
            <a href="/home">
                <img className='navbarDesktop__logo' src={logo} alt="logo" />
            </a>
            <a className='navbarDesktop__lien' href="/home">Accueil</a>
            <a className='navbarDesktop__lien' href="/about">A propos</a>
            <a className='navbarDesktop__lien' href="/services">Services</a>
            <a className='navbarDesktop__lien' href="/galerie">Galerie</a>
            <a className='navbarDesktop__lien' href="/contact">Contact</a>
        </nav>
    );
}

export default NavbarDesktop;
